import { FC } from 'react'
import ok from '@/assets/img/ok-green.png'
import { TypeIcon } from '@/components/Atoms/Icons/types'

const Icon: FC<TypeIcon> = ({ width = 30, height = 30 }) => {
  return (
    <img
      src={ok}
      alt='Success'
      width={width}
      height={height}
    />
  )
}

export default Icon
